import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { V_URL } from "../../../BaseUrl";
import toast from "react-hot-toast";

export const finalizeQuotation = createAsyncThunk('/quotation/create-store-quotation',
    async ({ id, payload }) => {
        try {
            const myurl = `${V_URL}/prosafe/quotation/${id}/finalize`;

            const response = await axios({
                method: 'put',
                url: myurl,
                data: payload,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });
            const data = response?.data;
            if (data.success === true) {
                toast.success(response?.data?.message || "Quotation Finalized Successfully");
                return data;
            } else {
                toast.error(response?.data?.message || "Something went wrong");
                throw new Error(response?.data?.message || "Something went wrong");
            }
        } catch (error) {
            toast.error("something went wrong");
            return error;
        }
    })

const finalizeQuotationSlice = createSlice({
    name: "finalizeQuotation",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(finalizeQuotation.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(finalizeQuotation.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(finalizeQuotation.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default finalizeQuotationSlice.reducer;